import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient from "../../../api/collection";

const useUpdateCollectionPlanMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      collectionId,
      planId,
    }: {
      collectionId: string;
      planId: string;
    }) => collectionApiClient.updateCollectionPlan(collectionId, planId),
    onSettled: (_data, _error, variables) =>
      Promise.all([
        queryClient.refetchQueries({ queryKey: ["collections"] }),
        queryClient.refetchQueries({
          queryKey: ["collection", variables.collectionId],
        }),
      ]),
  });
};

export default useUpdateCollectionPlanMutation;
